<template>
  <div class="dropdown-datepicker" ref="datepicker" :class="{ 'is--open': open, 'has--value': range ? query.range.start : query.date }">
    <div class="dropdown-datepicker__label" v-if="label">{{ label }}</div>
    <div class="dropdown-datepicker__selected" @click.prevent="open = !open">
      <template v-if="range">
        {{ query && query.range.start ? query.range.start + ' - ' + query.range.end : null }}        
      </template>
      <template v-else>
        {{ query.date }}     
      </template>
      <div class="dropdown-datepicker__arrow">
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M.51.945a.75.75 0 0 1 1.06 0l3.26 3.26a.243.243 0 0 0 .34 0L8.43.945a.75.75 0 1 1 1.06 1.06l-3.26 3.26a1.743 1.743 0 0 1-2.46 0L.51 2.005a.75.75 0 0 1 0-1.06Z" fill="#4D4D4D"/></svg>    
      </div>
    </div>
    <transition name="fade">
      <div class="dropdown-datepicker__dates" v-if="open">
      <v-date-picker
          v-if="open"
          v-model="vModel"
          mode="date"
          :masks="masks"
          :disabled-dates='disable_dates'
          :min-date="computedMinDate"
          :select-attribute="attributes"
          :drag-attribute="attributes"
          :model-config="modelConfig"
          :is-range="range"
          :columns="$screens({ default: 1, md: columns ? columns : 2 })"
          :is-expanded="true"
          @input="$emit('input',range ? query.range : query.date), open = !open"
      >
      </v-date-picker>
      </div>
    </transition>
  </div>
</template>

<script>
    import axios from 'axios'

    export default {
  name: 'DatePicker',
  data: () => ({
    open: false,
    disable_dates: [],
    query: {
      date: "",
      range: {
        start: "",
        end: ""
      }
    },
    masks: {
      input: 'DD MMMM',
      output: 'YYYY-MM-DD'
    },
    modelConfig: {
      type: 'string',
      mask: 'DD-MM-YYYY' // Uses 'iso' if missing
    },
    attributes: {
      highlight: {
        start: {
          style: {
            backgroundColor: '#000000' // black
          },
          contentStyle: {
            color: '#ffffff' // color of the text
          }
        },
        base: {
          style: {
            backgroundColor: '#F3F1F0' // light grey
          }
        },
        end: {
          style: {
            backgroundColor: '#000000' // black
          },
          contentStyle: {
            color: '#ffffff' // color of the text
          }
        }
      }
    }
  }),
  props: {
    id: {
        default: null,
        type: String
    },
    label: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    columns: {
      type: Number,
      required: false,
      default: null,
    },
    value: {
      type: [Object, String],
      required: false,
      default: null,
    },
    allowMinDate: {
        type: [Date, String, Boolean],
        default: false,
    },
    range: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabledDates: {
      type: Array,
      required: false,
      default: null
    }
  },
  watch: {
    query: {
      handler (value) {
      },
      deep: true,
      immediate: true
    },
    value: {
      handler (value) {
       if (this.value === null) {
        this.query.date = null
        this.query.range = {
          end: null,
          start: null
        }
       }
      },
      deep: true,
      immediate: true
    }
  },
  components: {
  },
  computed: {
      computedMinDate() {
          return this.allowMinDate ? new Date() : null;
      },
    vModel: {
      get () {
        if (this.range) {
          return this.query.range
        } else {
          return this.query.date
        }
      },
      set (val) {
        if (this.range) {
          return this.query.range = val
        } else {
          return this.query.date = val
        }
      }
    }
  },
  mounted () {
   if (this.value) {
    this.range ? this.query.range = this.value : this.query.date = this.value
   }
   if (this.disabledDates) {
    this.disable_dates = this.disabledDates
   }
   this.clickOutside()
  },
  created () {
  },
  methods: {
    clickOutside () {
      var self = this
      var parentEl = this.$refs.datepicker
      document.addEventListener('click', event => {
        if (!parentEl.contains(event.target)) {
          self.open = false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../scss/global/includes";

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.dropdown-datepicker {
  position: relative;
  width: 100%;
  margin-top: 8px;

  &.is--open {
    .dropdown-datepicker__arrow {
      @include transform(translateY(-50%) rotate(-180deg));
    }
  }
}

.dropdown-datepicker__selected {
  background: $white;
  border-radius: 8px;
  border: 0px;
  padding: 16px;
  cursor: pointer;
  user-select: none;
  line-height: 1;
  align-items: center;
  display: flex;
  position: relative;
  height: 64px;
  @include responsive-text-size('Body--16--Light');
  transition: all 0.3s ease-in-out;
  border: 1px solid $divider-dark;
}

.dropdown-datepicker__arrow {
  width: 10px;
  position: absolute;
  top: 50%;
  right: 15px;
  @include transform(translateY(-50%) rotate(0deg));
  transform-origin: center center;
  z-index: 1008;
  pointer-events: none;
  @include ease-fast;
}

.dropdown-datepicker__label {
  position: absolute;
  top: -10px;
  left: 10px;
  padding: 0px 6px 0 6px;
  @include responsive-text-size('Body--14--Regular');
  transition: all 0.3s ease-in-out;
  pointer-events: none;
  color: $grey;
  font-weight: normal;
  z-index: 1;
  &:after {
    width: 100%;
    position: absolute;
    background: #fff;
    z-index: -1;
    height: 1px;
    content: "";
    top: 10px;
    left: 0;
    right: 0;
  }
}

.dropdown-datepicker__dates {
  border-radius: 8px;
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vc-container {
  border: 0;
}

.vc-container .vc-weeks {
  padding: 20px 5px;
}

.vc-popover-content-wrapper {
  .vc-popover-content {
    box-shadow: rgba(0,0,0, 0.2) 0 6px 20px !important;
    border: 0;
  }
  .vc-weekday {
    color: $strong-light !important;
    font-size: 12px !important;
  }
  .vc-day-content.is-disabled {
    color: $mid-light !important;
  }
  .vc-day {
    padding: 10px;
  }
  .vc-header {
    padding: 20px 18px;
  }
  .vc-arrows-container {
    padding: 20px 10px;
  }
  .vc-pane {
    padding: 20px;
    @include breakpoint(tablet) {
      padding: 0;
    }
  }
  .vc-popover-caret {
    display: none;
  }
}
</style>
